import React from 'react';
import { Toast } from 'primereact/toast';
import './AIEduToast.css';

const AIEduToast = React.forwardRef((props, ref) => {
    return <Toast ref={ref} position='top-right' className='ai-edu-toast' />;
});

export default AIEduToast;
